import { httpClient } from './../httpClient';
import { apiErrorHandler } from './helpers';

const BILLING_URI = '/billing';
const BILLING_INVOICE_URI = `${BILLING_URI}/invoice`;

export const getInvoices = () =>
  httpClient
    .get(BILLING_INVOICE_URI)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getInvoicesByDate = yearWithMonth =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/date/${yearWithMonth}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getInoivceGraphData = (startMonth, endMonth) =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/graph?startMonth=${startMonth}&endMonth=${endMonth}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getHostWithNoInvoice = yearWithMonth =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/host-invoice/${yearWithMonth}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getLatestHostProtectRefNumber = () =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/hostProtectRef`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getInvoiceById = id =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getInvoiceByHost = id =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/host/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const createInvoice = payload =>
  httpClient
    .post(BILLING_INVOICE_URI, payload)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const updateInvoice = (id, payload) =>
  httpClient
    .put(`${BILLING_INVOICE_URI}/${id}`, payload)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getSubInvoiceByYear = year =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/host-billing/${year}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const updatePaymentStatus = token =>
  httpClient
    .put(`${BILLING_INVOICE_URI}/paymentStatus/`, { token })
    .then(response => response.data)
    .catch(apiErrorHandler);

export const deleteInvoice = payload =>
  httpClient
    .delete(`${BILLING_INVOICE_URI}/${payload.id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getPaymentSessionById = id =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/${id}/paymentSession`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const createPaymentViaFpx = payload =>
  httpClient
    .post(`${BILLING_INVOICE_URI}/payment`, payload)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getFpxPaymentStatus = token =>
  httpClient
    .put(`${BILLING_INVOICE_URI}/fpxPaymentStatus/`, { token })
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getHostStatus = () =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/host-status`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getInvoicePDFPreview = async payload => {
  try {
    const response = await httpClient.post(
      `${BILLING_INVOICE_URI}/pdf-preview`,
      { payload },
      {
        responseType: 'json' // Expect the response to be JSON
      }
    );

    if (response && response.data) {
      const { pdfBuffer, GrandTotal, invoiceSnapshot, message } = response.data;

      let pdfBlob = null;

      if (pdfBuffer) {
        try {
          // Convert base64 string back to Blob
          pdfBlob = new Blob(
            [
              new Uint8Array(
                atob(pdfBuffer)
                  .split('')
                  .map(c => c.charCodeAt(0))
              )
            ],
            { type: 'application/pdf' }
          );
        } catch (error) {
          console.error('Error decoding base64 PDF buffer:', error);
          pdfBlob = null; // Ensure it remains null if decoding fails
        }
      }

      return { pdfBlob, GrandTotal, invoiceSnapshot, message };
    } else {
      console.error('Received unexpected response format:', response.data);
      throw new Error('Unexpected response format');
    }
  } catch (error) {
    apiErrorHandler(error);
    throw error;
  }
};

export const getSnapshotValidationByInvoiceId = id =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/snapshot-validation/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getPrevMonthlyPrebuy = (id, monthWithYear) =>
  httpClient
    .get(`${BILLING_INVOICE_URI}/prev-monthly-prebuy/${id}?monthWithYear=${monthWithYear}`)
    .then(response => response.data)
    .catch(apiErrorHandler);
